import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

function load(component) {
    // '@' is aliased to src/components
    return () => import(`@/components/${component}.vue`)
}

const routes = [
    {
        path: '/',
        default: true,
        name: 'Buildings',
        component: load('Buildings'),
    },
    {
        path: '/contacts',
        name: 'Contacts',
        component: load('Contacts'),
    },
    {
        path: '/details/:buildingUuid',
        name: 'Details',
        component: load('Details'),
    },
    {
        path: '/users',
        name: 'Users',
        component: load('UserList'),
    },
    {
        path: '/messages/:buildingUuid',
        name: 'MessageList',
        component: load('MessageList'),
    },
    {
        path: '/debug',
        name: 'EwonDebugView',
        component: load('EwonDebugView'),
    },
    {
        path: '*',
        name: 'other',
        component: load('Buildings'),
    },
];

const router = new VueRouter({
    routes
});

router.beforeEach((to, from, next) => {
    if (!Vue.prototype.$keycloak.authenticated) {
        Vue.prototype.$keycloak.loginFn();
    }
    next();
});

export default router
